import BaseLayoutComponent from "../components/layouts/BaseLayoutComponent";
import { WhoWeAreComponent } from "../components/whoWeAre/WhoWeAreComponent";

export default function WhoWeAreScreen() {
  return (
    <BaseLayoutComponent showInstitutionalInfo>
      <WhoWeAreComponent />
    </BaseLayoutComponent>
  );
}